export const UPGRADE_SURFACES = [
    "sidebar_card",
    "usage_banner",
    "plan_page",
    "billing_page",
    "limit_banner",
] as const;

export type UpgradeSurface = (typeof UPGRADE_SURFACES)[number];
export type AttributedUpgradeSurface = UpgradeSurface | "unknown";

export const REMOTE_MCP_PRO_OFFER = {
    priceShown: 20,
    currency: "USD",
    billingPeriod: "month",
} as const;

export function parseUpgradeSurface(value: unknown): AttributedUpgradeSurface {
    return typeof value === "string" && (UPGRADE_SURFACES as readonly string[]).includes(value) ? (value as UpgradeSurface) : "unknown";
}
